import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import styled from 'styled-components';

import {RelativeFilterResponseBody} from '@dms/api/core';

import {suffixTestId, TestIdProps} from 'shared/web';

import {RelativeFilterPresetListItem} from './RelativeFilterPresetListItem';

interface SortableRelativeFilterPresetListItemProps extends TestIdProps {
  preset: RelativeFilterResponseBody;
  onOpen: () => void;
  onEdit: () => void;
}

export function SortableRelativeFilterPresetListItem(
  props: SortableRelativeFilterPresetListItemProps
) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.preset.id,
  });

  return (
    <SortableRow
      ref={setNodeRef}
      $transform={CSS.Transform.toString(transform) ?? undefined}
      $transition={transition ?? undefined}
      $isDragging={isDragging}
    >
      <RelativeFilterPresetListItem
        preset={props.preset}
        isSortable
        dragHandleAttributes={attributes}
        dragHandleListeners={listeners}
        onOpen={props.onOpen}
        onEdit={props.onEdit}
        data-testid={suffixTestId(`preset-${props.preset.id}`, props)}
      />
    </SortableRow>
  );
}

const SortableRow = styled.div<{
  $transform: string | undefined;
  $transition: string | undefined;
  $isDragging: boolean;
}>`
  transform: ${({$transform}) => $transform};
  transition: ${({$transition}) => $transition};
  opacity: ${({$isDragging}) => ($isDragging ? 0.5 : 1)};
`;
